import React from 'react';
import Styled from 'styled';
import { useQuery } from '@apollo/client/react/hooks';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import ImageView from 'lib/images/image-view';

import query, { InspirationsWidgetQuery, InspirationsWidgetQueryVariables } from './inspirations-widget.graphql';
import defaultStyles from './inspirations-widget.scss';

interface Props {
    styles: typeof defaultStyles;
    tagIds: string[];
}

const InspirationsWidget: React.FC<Props> = props => {
    const { styles, tagIds } = props;

    const { data } = useQuery<InspirationsWidgetQuery, InspirationsWidgetQueryVariables>(query, {
        variables: { tagIds },
    });

    if (data && data.taggedImages && data.taggedImages.edges) {
        return (
            <div className={styles.widget}>
                <div className={styles.widgetTitle}>
                    <FormattedMessage id='INSPIRATIONS_ON_THIS_TOPIC' />
                </div>
                <div className={styles.images}>
                    {data.taggedImages.edges.map(edge =>
                        edge && edge.node ? (
                            <Link to={edge.node.post && edge.node.post.href} className={styles.image}>
                                <ImageView aspectFill={true} linkify={false} {...(edge.node.photoFile as any)} />
                            </Link>
                        ) : null
                    )}
                </div>
            </div>
        );
    }

    return null;
};

export default Styled(defaultStyles)(InspirationsWidget);
